import React, { Component } from "react";
import { Route, Routes } from 'react-router-dom';
import ESG from "../components/ESG/ESG";
import RenderStock from "../components/StockMarketOverview/RenderStock";
import StockTradingApp from "../components/Investment/StockTradingApp";

import UserProfile from "../components/EditProfile/UserProfile";
import TransactionHistory from "../components/TransactionHistory/TransactionHistory"
import LandingPage from "../components/portfolio/landingpage";
import Login from "../components/Auth/Login/Login";

import BalanceAddPage from '../components/AddAmount/BalanceAddPage';

function DashboardRoutes() {
    return (
        <Routes>
            <Route path="esg" element={<ESG />} />
            <Route path="stockoverview" element={<RenderStock/>}/>
            <Route path="invest" element={<StockTradingApp />} />
            <Route path="portfolio" element={<LandingPage/>}/>
            <Route path="profile" element={<UserProfile/>}/>
            <Route path="transaction-history" element={<TransactionHistory/>}/>
            <Route path="add-amount" element={<BalanceAddPage />}/>
            {/* <Route path="logout" element={<Login/>}/> */}
        </Routes >
    )

}
export default DashboardRoutes;